var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48711 11.2243C2.90636 11.2243 2.43557 11.6951 2.43557 12.2759C2.43557 12.8566 2.90636 13.3274 3.48711 13.3274L10.8479 13.3274L10.8479 20.6883C10.8479 21.269 11.3187 21.7398 11.8995 21.7398C12.4802 21.7398 12.951 21.269 12.951 20.6883L12.951 13.3274H20.3119C20.8926 13.3274 21.3634 12.8566 21.3634 12.2759C21.3634 11.6951 20.8926 11.2243 20.3119 11.2243H12.951L12.951 3.8635C12.951 3.28275 12.4802 2.81195 11.8995 2.81195C11.3187 2.81195 10.8479 3.28274 10.8479 3.8635L10.8479 11.2243L3.48711 11.2243Z",
    fill: "#92C99A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dfb43eec78df39537a51d96ab3d0b03b.svg";
export { ForwardRef as ReactComponent };